import { motion } from 'framer-motion';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-r from-primary to-primary-dark text-white overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://rentfi.b-cdn.net/rentfi-bg.webp')] bg-center opacity-50 pointer-events-none [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))]" 
           role="presentation" 
           aria-hidden="true"></div>
      
      <div className="relative pt-24 pb-48">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center space-y-12"
          >
            <motion.div 
              className="mb-12"
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <img 
                src="https://rentfi.b-cdn.net/rentfi-logo-monochrome.webp" 
                alt="RentFi - The REIT of the Blockchain" 
                className="w-[175px] md:w-[210px] h-auto mx-auto"
                loading="lazy"
                width="1200"
                height="658"
              />
            </motion.div>
            <motion.div
              className="space-y-8"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.5 }}
            >
              <div className="max-w-2xl mx-auto">
                <h1 className="text-secondary-light text-[48px] leading-[56px] mb-12">
                  The REIT of the Blockchain
                </h1>
                <div className="space-y-4 mb-20">
                  <p className="text-body-large text-gray-200">
                    Revolutionizing real estate investment through blockchain technology.
                  </p>
                  <p className="text-body-large text-gray-200">
                    Generate passive income with high-yield properties.
                  </p>
                </div>
              </div>
            </motion.div>
            <motion.div
              className="flex flex-col sm:flex-row gap-6 justify-center items-center relative z-10"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
            >
              <a
                href="https://raydium.io/swap/?inputMint=sol&outputMint=EPW6L3UrX8ArF4SVsGFNNNs2XccugnJGNNzXLeHUCNuz"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-cta text-lg font-semibold group flex items-center gap-2"
                aria-label="Trade RENT tokens on Raydium decentralized exchange"
                data-tracking="cta-click"
                data-tracking-location="hero"
                data-tracking-destination="raydium"
              >
                Trade on Raydium
                <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </a>
              <Link
                to="/faq"
                className="btn-secondary flex items-center gap-2"
                aria-label="Learn more about RentFi's real estate investment platform"
              >
                Learn More
                <ArrowRightIcon className="w-4 h-4" />
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}